import { supabase } from '@/lib/supabase'

const KEY = 'ops.webpush_enabled_for_all'

export async function getWebpushEnabledForAll(): Promise<boolean> {
  const { data, error } = await supabase.from('app_settings').select('value').eq('key', KEY).maybeSingle()
  if (error) throw error
  return ((data?.value as string) || 'false') === 'true'
}

export async function setWebpushEnabledForAll(on: boolean): Promise<void> {
  const { error } = await supabase.from('app_settings').upsert({ key: KEY, value: on ? 'true' : 'false' }, { onConflict: 'key' })
  if (error) throw error
}

